<template>
  <div>
    <column-chart
      :data="datoGrafica1"
      suffix="%"
      :download="true"
      :colors="[['#106b21',  '#fce903', '#ce0018']]"></column-chart>
  </div>
</template>


<script>
import {mapState  } from "vuex";
export default {
  name: 'graficasCumplimiento',
  data() {
    return {
       colors: [["#106b21"],  "#fce903", "#ce0018"]
    }
  },
  computed: {
         ...mapState('listaChequeo',[
            'datoGrafica1',
        ]),
    },
}
</script>
